import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SuggestPrompt(
    $projectId: ID!
    $freestyleToolAllInstructionsData: JSON
    $freestyleToolId: ID
    $numberOfVariations: Int!
    $debugAcPrompt: String
    $generationTool: GenerationToolEnum
    $type: SuggestPromptTypeEnum
    $urlExtractions: [UrlExtractionInput!]
  ) {
    suggestPrompt(
      projectId: $projectId
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
      freestyleToolId: $freestyleToolId
      numberOfVariations: $numberOfVariations
      debugAcPrompt: $debugAcPrompt
      generationTool: $generationTool
      type: $type
      urlExtractions: $urlExtractions
    ) {
      suggestedPrompt
      html
      ratingCount
    }
  }
`;

export const suggestPrompt = async ({
  projectId,
  numberOfVariations,
  debugAcPrompt,
  freestyleToolId,
  freestyleToolAllInstructionsData,
  generationTool,
  type,
  urlExtractions,
}) => {
  const variables = {
    projectId,
    numberOfVariations,
    debugAcPrompt,
    freestyleToolId,
    freestyleToolAllInstructionsData,
    generationTool,
    type,
    urlExtractions,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp(response.data);
};
